<template>
	<div class="modal-popup" style="visibility: visible;" id="modal_popup_idle">
		<div class="modal__title">
			<span>{{ $t("idleBrowserTitle") }}</span>
		</div>
		<div class="modal-popup-content">
			<p>{{ $t("idleBrowserMessage") }}</p>
			<p>{{ $t("idleBrowserTimeLeft") }}</p>
		</div>
	</div>
</template>

<script>
import utils from "@/plugins/utils.js";

export default {
	data() {
		return {
			time: 15000,
		};
	},
	created() {
		let timerId = setInterval(() => {
			this.time -= 1000;
			if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
			if (this.time < 1) {
				clearInterval(timerId);
				utils.logout();
			}
		}, 1000);
	},
	computed: {
		second() {
			return this.time / 1000;
		},
	},
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
